import { render, staticRenderFns } from "./EntregaSolicitarReabertura.vue?vue&type=template&id=dbd98300"
import script from "./EntregaSolicitarReabertura.vue?vue&type=script&lang=js"
export * from "./EntregaSolicitarReabertura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports